import React, { Component } from 'react'

export default ({ className, width, height }) => {
    return (
        <svg className={className} width={width} height={height} viewBox="0 0 28 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path fill="#fff" d="M 25.9107 1.85714C 26.3274 1.85714 26.6845 2.00595 26.9821 2.30357C 27.2798 2.60119 27.4286 2.95833 27.4286 3.375L 27.4286 27.7679C 27.4286 28.1845 27.2798 28.5417 26.9821 28.8393C 26.6845 29.1369 26.3274 29.2857 25.9107 29.2857L 18.9286 29.2857L 18.9286 18.6607L 22.4821 18.6607L 23.0179 14.5179L 18.9286 14.5179L 18.9286 11.875C 18.9286 11.2083 19.0655 10.7083 19.3393 10.375C 19.625 10.0417 20.1726 9.875 20.9821 9.875L 23.1607 9.85714L 23.1607 6.16072C 22.4107 6.05357 21.3512 6 19.9821 6C 18.3631 6 17.0655 6.47619 16.0893 7.42857C 15.125 8.38095 14.6429 9.72619 14.6429 11.4643L 14.6429 14.5179L 11.0714 14.5179L 11.0714 18.6607L 14.6429 18.6607L 14.6429 29.2857L 1.51786 29.2857C 1.10119 29.2857 0.744048 29.1369 0.446429 28.8393C 0.14881 28.5417 0 28.1845 0 27.7679L 0 3.375C 0 2.95833 0.14881 2.60119 0.446429 2.30357C 0.744048 2.00595 1.10119 1.85714 1.51786 1.85714L 25.9107 1.85714Z" />
        </svg>

    )
}







// WEBPACK FOOTER //
// ./src/components/visuals/social/Facebook.js